export const franceAllowedPublishStatus = [
  "NOT SUBMITTED",
  "DRAFT",
  "REVIEW COMPLETE",
  "PENDING HEALTH AUTHORITY SUBMISSION",
  "APPROVED FOR PRODUCTION",
];

export const getColor = (status) => {
  if (status === "Approved for Use" || "Available for Use") return "#E1EDDA";
  if (status === ("Draft" || "Expired" || "Withdrawn")) return "#F0F0F0";
  if (status === ("In Business Owner Review" || "Approval Complete" || "Librarian QC")) return "#FDE9DF";
  return "";
};
